import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrearEncuestaComponent } from './crear-encuesta.component';
import { RouterModule, Routes } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatListModule} from '@angular/material/list';
import {MatTabsModule} from '@angular/material/tabs';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';

import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { FuseSharedModule } from '@fuse/shared.module';
import { FuseConfirmDialogModule, FuseSidebarModule,FuseWidgetModule } from '@fuse/components';
import {MatTooltipModule} from '@angular/material/tooltip';
@NgModule({
  declarations: [CrearEncuestaComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatRippleModule,
    MatTableModule,
    MatToolbarModule,
    MatButtonToggleModule,

    FuseSharedModule,
    FuseConfirmDialogModule,
    FuseSidebarModule,
    FuseWidgetModule,
    MatListModule,
    MatTooltipModule,
    MatTabsModule,
    BrowserAnimationsModule,
    TranslateModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatCardModule,
    MatDividerModule
  ]
})
export class CrearEncuestaModule { }
